
export default {
  namespaced: true,
  state () {
    return {
      vnClassrooms: [
        {
          id: 1,
          img: 'p1.png',
          name: 'Phòng học lý thuyết'
        },
        {
          id: 2,
          img: 'p2.png',
          name: 'Phòng học lý thuyết chuyển loại dành cho phi công'
        },
        {
          id: 3,
          img: 'p3.png',
          name: 'Phòng học an toàn bay'
        },
        {
          id: 4,
          img: 'p4.png',
          name: 'Phòng học sơ cứu'
        },
        {
          id: 5,
          img: 'p5.png',
          name: 'Phòng học an ninh'
        },
        {
          id: 6,
          img: 'p6.png',
          name: 'Phòng máy vi tính'
        },
        {
          id: 7,
          img: 'p7.png',
          name: 'Phòng học phục vụ ẩm thực'
        },
        {
          id: 8,
          img: 'p8.png',
          name: 'Phòng học trang điểm'
        },
        {
          id: 9,
          img: 'p9.jpg',
          name: 'Phòng học phục vụ'
        }
      ],
      enClassrooms: [
        {
          id: 1,
          img: 'p1.png',
          name: 'Theory Classroom'
        },
        {
          id: 2,
          img: 'p2.png',
          name: 'Type Rating Theory Classroom for Pilots'
        },
        {
          id: 3,
          img: 'p3.png',
          name: 'Flight Safety Classroom'
        },
        {
          id: 4,
          img: 'p4.png',
          name: 'First Aid Classroom'
        },
        {
          id: 5,
          img: 'p5.png',
          name: 'Security Classroom'
        },
        {
          id: 6,
          img: 'p6.png',
          name: 'Computer Room'
        },
        {
          id: 7,
          img: 'p7.png',
          name: 'Culinary Service Classroom'
        },
        {
          id: 8,
          img: 'p8.png',
          name: 'Makeup Classroom'
        },
        {
          id: 9,
          img: 'p9.jpg',
          name: 'Service Classroom'
        }
      ],
      vnDevices: [
        {
          id: 1,
          img: 'h2.png.jpg',
          name: 'Buồng lái mô phỏng A321'
        },
        {
          id: 2,
          img: 'h3.png',
          name: 'Thiết bị huấn luyện bay A320'
        },
        {
          id: 3,
          img: 'h4.png',
          name: 'Mô hình khoang khách giả A320'
        },
        {
          id: 4,
          img: 'h5.png',
          name: 'Cửa huấn luyện B787 & A350'
        },
        {
          id: 5,
          img: 'h6.png',
          name: 'Hồ bơi tạo sóng'
        },
        {
          id: 6,
          img: 'h7.png',
          name: 'Mô hình huấn luyện chữa cháy'
        }
      ],
      enDevices: [
        {
          id: 1,
          img: 'h2.png.jpg',
          name: 'A321 Flight Simulator'
        },
        {
          id: 2,
          img: 'h3.png',
          name: 'A320 Flight Training Device'
        },
        {
          id: 3,
          img: 'h4.png',
          name: 'A320 Mock Cabin'
        },
        {
          id: 4,
          img: 'h5.png',
          name: 'B787 & A350 Training Door'
        },
        {
          id: 5,
          img: 'h6.png',
          name: 'Wave Pool'
        },
        {
          id: 6,
          img: 'h7.png',
          name: 'Fire Training Simulator'
        }
      ]
    }
  },
  getters: {
    finalClassrooms (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.vnClassrooms
      } else {
        return state.enClassrooms
      }
    },
    finalDevices (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        return state.vnDevices
      } else {
        return state.enDevices
      }
    }
  }
}
